import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Menu, MenuItem, ListItemText, Divider, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const EventMenu = ({ anchorEl, open, onClose, onAllEvents, onCreateEvent }) => {
    const theme = useTheme();
    const location = useLocation();
    const { t } = useTranslation();
    const menuItems = [
        {
            id: 'create-event',
            label: t('events.createEvent'),
            onClick: onCreateEvent,
            path: '/create-event'
        },
        {
            id: 'all-events',
            label: t('events.allEvents'),
            onClick: onAllEvents,
            path: '/events'
        }
    ];
    return (_jsx(Menu, { anchorEl: anchorEl, open: open, onClose: onClose, anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        }, PaperProps: {
            sx: {
                minWidth: 200,
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                '& .MuiMenuItem-root': {
                    px: 2,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[50]
                    }
                }
            }
        }, children: menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (_jsxs(React.Fragment, { children: [_jsx(MenuItem, { onClick: () => {
                            item.onClick?.();
                            onClose();
                        }, sx: {
                            backgroundColor: isActive ? theme.palette.action.selected : 'transparent'
                        }, children: _jsx(ListItemText, { primary: item.label, sx: {
                                '& .MuiListItemText-primary': {
                                    fontSize: '14px',
                                    fontWeight: isActive ? 600 : 500,
                                    color: isActive ? theme.palette.primary.dark : theme.palette.grey[800]
                                }
                            } }) }), index < menuItems.length - 1 && _jsx(Divider, { sx: { mx: 1 } })] }, item.id));
        }) }));
};
export default EventMenu;
